import { BenefitDetails } from "@/stores/risk/types/types";
import { QuoteDisplayTableProp } from "@mbs-npm/anpost-ui";

export interface BenefitState {
    hasBuildingsCovered: boolean;
    hasContentsCovered: boolean;
    hasHomeEmergency: boolean;
    hasFireBrigadeCharges: boolean;
    hasLegalLiability: boolean;
    ipid: string;
    building_and_contents?: Array<BenefitDetails>;
    contents_only?: Array<BenefitDetails>;
}

export type TableQuoteObject = {
    info: QuoteDisplayTableProp;
} & BenefitState;

export enum TableHeaderKey {
    INSURER_LIST = "list-of-insurers",
    BUILDINGS_COVERED = "buildings-covered",
    CONTENTS_COVERED = "contents-covered",
    HOME_EMERGENCY = "home-emergency-response",
    FIRE_BRIGADE_CHARGES = "fire-brigade-charges",
    LEGAL_LIABILITY = "legal-liability",
    IPID = "ipid",
    ACTIONS = "actions"
}

export enum QuoteDocumentsTypeKey {
    STATEMENT_OF_FACTS = "StatementOfFact"
}
